import React from 'react';
import FlatIcon from './FlatIcon';

/*
    Icona del pulsante a schermo intero. Le due versioni sono sempre nel DOM e quale si vede lo decide
    App.css dalla classe is-fullscreen su <html>, che imposta globalVars.fullscreen: il pulsante cambia
    anche senza un nuovo render (es. Esc per uscire dallo schermo intero).
*/
const FullscreenIcon = ({ size = 55, weight = 2.4 }) => (
    <>
        <FlatIcon name="fullscreen" size={size} weight={weight} className="fs-enter" />
        <FlatIcon name="fullscreenExit" size={size} weight={weight} className="fs-exit" />
    </>
);

export default FullscreenIcon;
